import InvalidUsernameCharactersInlineMessage from './InvalidUsernameCharactersInlineMessage';

export default InvalidUsernameCharactersInlineMessage;
